import MVCPFlatList from './MVCPFlatList';

export default MVCPFlatList;
